import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './../node_modules/jquery/dist/jquery';
import './../node_modules/popper.js/dist/popper';
import './../node_modules/bootstrap/dist/js/bootstrap.bundle';

import './../node_modules/chart.js/dist/chart.min.js';

import './../node_modules/flag-icons/css/flag-icons.min.css';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store, { persistor } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import { Providers } from './Providers';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Providers>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Providers>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
